export default "__VITE_ASSET__efc910d7__"